/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type GetLocalizedLabelsQueryVariablesGQLType = Types.Exact<{
  scope: Types.Scalars['String'];
}>;


export type GetLocalizedLabelsQueryGQLType = (
  { __typename?: 'Query' }
  & { getLocalizedLabels?: Types.Maybe<(
    { __typename?: 'LocalizedLabels' }
    & Pick<Types.LocalizedLabelsGQLType, 'scope'>
    & { labels: Array<(
      { __typename?: 'LocalizedLabel' }
      & Pick<Types.LocalizedLabelGQLType, 'labelKey' | 'localizedValue'>
    )> }
  )> }
);


export const GetLocalizedLabelsDocumentGQLType = gql`
    query GetLocalizedLabels($scope: String!) {
  getLocalizedLabels(scope: $scope) {
    scope
    labels {
      labelKey
      localizedValue
    }
  }
}
    `;

/**
 * __useGetLocalizedLabelsQuery__
 *
 * To run a query within a React component, call `useGetLocalizedLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocalizedLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocalizedLabelsQuery({
 *   variables: {
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useGetLocalizedLabelsQuery(baseOptions: Apollo.QueryHookOptions<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>(GetLocalizedLabelsDocumentGQLType, options);
      }
export function useGetLocalizedLabelsLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>(GetLocalizedLabelsDocumentGQLType, options);
        }
export type GetLocalizedLabelsQueryHookResult = ReturnType<typeof useGetLocalizedLabelsQuery>;
export type GetLocalizedLabelsLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLocalizedLabelsLazyQueryGQLType>;
export type GetLocalizedLabelsQueryResultGQLType = Apollo.QueryResult<GetLocalizedLabelsQueryGQLType, GetLocalizedLabelsQueryVariablesGQLType>;